import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from "@angular/core";
import { LogHistorial } from "app/dto/log-historial.dto";
import { FieldConfig } from "app/genericForm/field.interface";
import { LogService } from "app/service/log.service";

@Component({
  selector: "app-historial",
  templateUrl: "./historial.component.html",
  styleUrls: ["./historial.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HistorialComponent implements OnInit {
  @Input() field: FieldConfig;

  lista: LogHistorial[] = [];
  @HostBinding("class") class = "";

  constructor(private logService: LogService) {}

  async ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    if (this.field.idEntidad && this.field.nombreEntidad)
      await this.logService
        .historial(
          this.field.idEntidad,
          this.field.nombreEntidad,
          this.field.accionEntidad
        )
        .toPromise()
        .then((d) => (this.lista = d));
  }

  hidden(row: LogHistorial) {
    return !(row.valoresAntiguos && row.valoresModificados);
  }
}
